<template>
  <div class="content">
    <SogCard>
      <SogCardTitle>
        {{ data?.insuranceNumber }}
      </SogCardTitle>
      <SogCardContent>
        <table style="width: 100%">
          <tr v-show="data?.partnershipId">
            <td>PartnershipId</td>
            <td><SogDataLabel :value="data?.partnershipId" /></td>
          </tr>
          <tr>
            <td>eVb</td>
            <td><SogDataLabel :value="data?.evb" /></td>
          </tr>
          <tr>
            <td>Kennzeichen</td>
            <td><SogDataLabel>{{ data?.kennzeichen }}</SogDataLabel></td>
          </tr>
          <tr>
            <td>Versicherungsbeginn</td>
            <td>
              <SogDataLabel
                :value="data?.datumVersicherungsBeginn"
                value-type="DateTime"
              />
            </td>
          </tr>
          <tr>
            <td>Versicherungsende</td>
            <td>
              <SogDataLabel
                :value="data?.kennzeichenDatumGueltigBis"
                value-type="DateTime"
              />
            </td>
          </tr>
          <tr>
            <td>FIN</td>
            <td><SogDataLabel>{{ data?.fahrzeugIdentifizierungsNummer }}</SogDataLabel></td>
          </tr>
          <tr>
            <td>Fahrzeugart</td>
            <td><SogDataLabel>{{ data?.fahrzeugArtDescription }}</SogDataLabel></td>
          </tr>
          <tr>
            <td>Hersteller</td>
            <td><SogDataLabel>{{ data?.fahrzeugHersteller }}</SogDataLabel></td>
          </tr>
          <tr>
            <td>Text Fahrzeugklasse</td>
            <td><SogDataLabel>{{ data?.textFahrzeugklasse }}</SogDataLabel></td>
          </tr>
          <tr>
            <td>Text Aufbau</td>
            <td><SogDataLabel>{{ data?.textAufbau }}</SogDataLabel></td>
          </tr>
          <tr>
            <td>Haltername</td>
            <td><SogDataLabel>{{ data?.halterVorname }} {{ data?.halterNachname }}</SogDataLabel></td>
          </tr>
          <tr>
            <td>Halteraddresse</td>
            <td><SogDataLabel>{{ data?.halterStrasse }} {{ data?.halterHausnummer }}</SogDataLabel></td>
          </tr>
          <tr>
            <td />
            <td><SogDataLabel>{{ data?.halterPostleitzahl }} {{ data?.halterWohnort }}<br>{{ data?.halterStaat }}</SogDataLabel></td>
          </tr>
        </table>
      </SogCardContent>
    </SogCard>
  </div>
</template>

<script setup lang="ts">

import DtoSearch from "@/shared/model/DtoSearch";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";

interface Props {
  data?:DtoSearch,
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(),{
    data:undefined
  }
)


</script>

<style scoped>
.content{
  max-width: 400px;
}
td{
  padding-right: 5px;
}
</style>
